"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siloHistoryFrontColumnProps = exports.siloHistoryColumnProps = exports.siloColumnProps = void 0;
const constants_1 = require("utils/constants");
exports.siloColumnProps = [
    {
        show: true,
        field: 'silo_code',
        title: 'Silo Code',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'silo_name',
        title: 'Silo Name',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '140px',
        filter: 'text',
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '120px',
        filter: 'boolean',
    },
];
exports.siloHistoryColumnProps = [
    {
        show: true,
        field: 'ticket_no',
        title: 'Ticket No',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler No',
        width: '110',
        filter: 'text',
    },
    {
        show: true,
        field: 'transaction_type',
        title: 'Type',
        width: '100',
        filter: 'text',
    },
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Date',
        width: 'auto',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    },
];
exports.siloHistoryFrontColumnProps = [
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler No',
        width: 'auto',
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Date',
        width: 'auto',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`,
    }
];
